<div *ngIf="isLoading" class="opt-out-wrapper">You are being redirected to Sync's older interface.<sync-icon name="Rolling-1s-40px" /></div>